import { Pipe, PipeTransform, inject } from '@angular/core';
import { ENVIRONMENT, SharedEnv } from 'shared-ui/di/environment';

@Pipe({
  name: 'imageUrl',
  standalone: false,
})
export class ImageUrlPipe implements PipeTransform {
  private env = inject<SharedEnv>(ENVIRONMENT);

  transform(image: string, namespace: string, entityId?: string) {
    const url = ImageUrlPipe.getUrl(this.env, image, namespace, entityId);
    return url;
  }

  static getUrl(env: SharedEnv, image: string, namespace: string, entityId?: string): string {
    return `${env.imagesUrl}/${namespace}${entityId ? `/${entityId}` : ''}/${image}`;
  }
}

export function imageUrlFactory() {
  const env = inject<SharedEnv>(ENVIRONMENT);
  return (image: string, namespace: string, entityId?: string) => ImageUrlPipe.getUrl(env, image, namespace, entityId);
}
